import React from 'react'
import {
  Industries,
  Departments,
  Scales,
  DocumentTypes
} from '@/types/newt/voice'

interface SelectedFiltersProps {
  selectedIndustries: string[]
  selectedDepartments: string[]
  selectedScales: string[]
  selectedDocumentTypes: string[]
  industries: Industries[]
  departments: Departments[]
  scales: Scales[]
  documentTypes: DocumentTypes[]
}

export function SelectedFilters({
  selectedIndustries,
  selectedDepartments,
  selectedScales,
  selectedDocumentTypes,
  industries,
  departments,
  scales,
  documentTypes
}: SelectedFiltersProps) {
  const totalSelectedConditions =
    selectedIndustries.length +
    selectedDepartments.length +
    selectedScales.length +
    selectedDocumentTypes.length

  if (totalSelectedConditions === 0) return null

  return (
    <div className="bg-lawguebase flex flex-col gap-y-[10px] lg:gap-x-2 lg:flex-row lg:items-center rounded-[8px] py-2 px-5 mt-6">
      <h3 className="text-xs leading-normal lg:leading-[18px] lg:flex gap-x-2">
        絞り込み条件
        <span className="hidden lg:block text-base leading-[18px]">：</span>
      </h3>
      <ul className="flex flex-wrap gap-x-6 text-base leading-[2] lg:flex-1">
        {selectedIndustries.map((industry) => (
          <li key={industry}>
            {industries.find((ind) => ind.slug === industry)?.name}
          </li>
        ))}
        {selectedDepartments.map((department) => (
          <li key={department}>
            {departments.find((dep) => dep.slug === department)?.name}
          </li>
        ))}
        {selectedScales.map((scale) => (
          <li key={scale}>{scales.find((sc) => sc.slug === scale)?.name}</li>
        ))}
        {selectedDocumentTypes.map((documentType) => (
          <li key={documentType}>
            {documentTypes.find((doc) => doc.slug === documentType)?.name}
          </li>
        ))}
      </ul>
    </div>
  )
}
